import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { Navigate } from 'react-router-dom';

/**
 * Landing route for the Keycloak redirect (`/auth/callback`). The OIDC
 * provider intercepts the `?code=...&state=...` query before this renders,
 * so we just wait for the user object to materialise and bounce to the
 * intended destination (which we stashed in the OIDC `state` field).
 */
export function AuthCallbackPage() {
  const auth = useAuth();

  useEffect(() => {
    if (auth.error) {
      console.error('OIDC callback failed:', auth.error);
    }
  }, [auth.error]);

  if (auth.error) {
    return <Navigate to="/login" replace />;
  }
  if (auth.isAuthenticated) {
    const state = typeof auth.user?.state === 'string' ? auth.user.state : '/workspaces';
    return <Navigate to={state} replace />;
  }
  return (
    <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
      Completing sign-in…
    </div>
  );
}
